module.exports = __webpack_public_path__ + "static/media/BoxPlotQ6_1.14fc2d15.svg";